<template>
  <el-dialog :title="$t('communityDataToHuishLife.title')" :visible.sync="visible" width="30%"
    @close="closeCommunityDataToHuishLifeModel">
    <div style="text-align: center">
      <p>{{ $t('communityDataToHuishLife.confirmText') }}</p>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeCommunityDataToHuishLifeModel">{{ $t('communityDataToHuishLife.cancel') }}</el-button>
      <el-button type="primary" @click="_toSendCommunityDataToHuishLife">{{ $t('communityDataToHuishLife.confirm') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { sendCommunityToHuishLife } from '@/api/community/communityManageApi'

export default {
  name: 'CommunityDataToHuishLife',
  data() {
    return {
      visible: false,
      communityDataToHuishLifeInfo: {
        communityId: '',
        communityName: ''
      }
    }
  },

  methods: {
    openModal(params) {
      Object.assign(this.communityDataToHuishLifeInfo, params)
      this.visible = true
    },
    _toSendCommunityDataToHuishLife() {
      sendCommunityToHuishLife(this.communityDataToHuishLifeInfo).then(res => {
        console.log(res)
        this.$message.success(this.$t('communityDataToHuishLife.syncSuccess'))
        this.visible = false
      }).catch(error => {
        this.$message.error(error.message)
      })
    },
    closeCommunityDataToHuishLifeModel() {
      this.visible = false
    }
  }
}
</script>

